import React from 'react';
import { Button, Flex } from '@spothero/ui';
const MultiSelectDatePickerFooter = ({ onClear, onDone, }) => {
    return (<Flex align="center" justify="end" width="full" data-testid="MultiSelectDatePickerFooter" mt="2">
            <Button variant="tertiary" padding="4" onClick={onClear} data-testid="MultiSelectDatePickerFooter-clear-button">
                Clear
            </Button>
            <Button onClick={onDone} data-testid="MultiSelectDatePickerFooter-done-button">
                Done
            </Button>
        </Flex>);
};
export default MultiSelectDatePickerFooter;
